import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "report-title" }


export default /*#__PURE__*/_defineComponent({
  __name: 'VFullRadioGroup',
  props: {
    label: null,
    tooltips: null,
    items: null
  },
  setup(__props: any) {

const props = __props as { label: string, tooltips?: {[ key: string ]: string }, items: {[ key: string ]: string } }





return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createBlock(_component_v_radio_group, { color: "primary" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.label), 1),
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", {
        class: _normalizeClass(["radio-row", { 'info-column': !!__props.tooltips }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (name, key) => {
          return (_openBlock(), _createBlock(_component_v_radio, {
            label: name,
            value: key
          }, _createSlots({ _: 2 }, [
            (__props.tooltips)
              ? {
                  name: "label",
                  fn: _withCtx(({ label }) => [
                    _createTextVNode(_toDisplayString(label) + " ", 1),
                    _createVNode(_component_v_tooltip, {
                      text: __props.tooltips![name],
                      "max-width": "400"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps(props, {
                          icon: "mdi-information-outline",
                          size: "x-small",
                          color: "grey",
                          class: "h-6"
                        }), null, 16)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["label", "value"]))
        }), 256))
      ], 2)
    ]),
    _: 3
  }))
}
}

})